import React, { createContext, useContext, useState } from 'react';
import { FullScreenLoader } from '../../ui-kit/FullScreenLoader';

interface ContextProps {
    isVenueSwitching: boolean;
    setIsVenueSwitching(flag: boolean): void;
}

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
const defaultState = {
    isVenueSwitching: false,
    setIsVenueSwitching: (flag: boolean) => {},
};
/* eslint-enable @typescript-eslint/no-empty-function */
/* eslint-enable @typescript-eslint/no-unused-vars */

const VenueSwitchContext = createContext<ContextProps>(defaultState);

export const ProvideVenueShiftContext: React.FC = ({ children }) => {
    const context = useProvideVenueSwitch();
    return (
        <VenueSwitchContext.Provider value={context}>
            {context.isVenueSwitching
            ? (
                <FullScreenLoader />
            ) : children}
        </VenueSwitchContext.Provider>
    );
};

export const useVenueSwitchContext = () => {
    return useContext(VenueSwitchContext);
};

function useProvideVenueSwitch() {
    const [isVenueSwitching, setIsVenueSwitching] = useState(false);

    return { isVenueSwitching, setIsVenueSwitching };
}
